"use strict";
// LuXe : effets d'animation de l'accueil (progression, halos, particules, relief des cartes, reflets…).
// Rien ne s'active si le visiteur a demandé « réduire les animations ». Pas d'effets qui suivent la souris (désactivés à la demande d'Axel).
(function () {
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const souris = false;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  root.classList.add("fx");

  const el = (tag, cls, parent) => { const n = document.createElement(tag); n.className = cls; (parent || document.body).appendChild(n); return n; };

  // ---------- Barre de progression de lecture ----------
  const barre = el("div", "fx-progress");
  barre.setAttribute("aria-hidden", "true");
  let ticking = false;
  const maj = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    barre.style.transform = `scaleX(${h > 0 ? clamp(scrollY / h, 0, 1) : 0})`;
    ticking = false;
  };
  addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(maj); } }, { passive: true });
  maj();

  // ---------- Halos dorés qui dérivent en fond ----------
  el("i", "fx-orb a").setAttribute("aria-hidden", "true");
  el("i", "fx-orb b").setAttribute("aria-hidden", "true");

  // ---------- Particules dorées dans le héros ----------
  const hero = $(".hero");
  if (hero) {
    const n = innerWidth < 700 ? 10 : 24;
    for (let i = 0; i < n; i++) {
      const s = el("i", "fx-spark", hero);
      const t = 2 + Math.random() * 4;
      s.style.cssText = `left:${Math.random() * 100}%;width:${t}px;height:${t}px;--dx:${(Math.random() - 0.5) * 120}px;animation-duration:${7 + Math.random() * 9}s;animation-delay:${-Math.random() * 12}s`;
      s.setAttribute("aria-hidden", "true");
    }
  }

  // ---------- Titres : apparition mot par mot ----------
  $$("section h2.rv").forEach((h) => {
    let i = 0;
    const wrap = (txt, cls) => {
      const frag = document.createDocumentFragment();
      txt.split(/(\s+)/).forEach((m) => {
        if (!m) return;
        if (/^\s+$/.test(m)) { frag.appendChild(document.createTextNode(" ")); return; }
        const w = document.createElement("span"); w.className = "fx-w";
        const s = document.createElement("span"); s.style.setProperty("--i", i++); s.textContent = m;
        if (cls) s.className = cls;
        w.appendChild(s); frag.appendChild(w);
      });
      return frag;
    };
    [...h.childNodes].forEach((n) => {
      if (n.nodeType === 3) n.replaceWith(wrap(n.textContent));
      else if (n.nodeType === 1) n.replaceWith(wrap(n.textContent, n.className));
    });
  });

  // ---------- Relief + reflet doré sur les cartes (souris uniquement) ----------
  const cartes = $$(".pcard, .stat, .soon, .val");
  cartes.forEach((c) => { c.classList.add("fx-card"); const g = document.createElement("i"); g.className = "fx-glare"; g.setAttribute("aria-hidden", "true"); c.appendChild(g); });
  if (souris) {
    cartes.forEach((c) => {
      let raf = 0;
      // L'effet 3D démarre une fois l'apparition de la carte terminée (sinon il se bat avec l'animation d'entrée).
      const pret = () => c.classList.contains("in") && !c.getAnimations().some((a) => a.transitionProperty === "transform");
      c.addEventListener("pointermove", (e) => {
        if (!c.classList.contains("tilt-on")) { if (pret()) c.classList.add("tilt-on"); else return; }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          c.style.setProperty("--ry", `${((x - 0.5) * 10).toFixed(2)}deg`);
          c.style.setProperty("--rx", `${((0.5 - y) * 8).toFixed(2)}deg`);
          c.style.setProperty("--mx", `${(x * 100).toFixed(1)}%`);
          c.style.setProperty("--my", `${(y * 100).toFixed(1)}%`);
        });
      });
      c.addEventListener("pointerleave", () => { cancelAnimationFrame(raf); c.style.setProperty("--rx", "0deg"); c.style.setProperty("--ry", "0deg"); });
    });
  }

  // ---------- Héros : relief 3D qui suit la souris, halo, anneau à chaque changement de T-shirt ----------
  const hud = $(".fx-hud");
  if (hud) {
    const ring = el("i", "hud-ring", hud);
    ring.setAttribute("aria-hidden", "true");
    const tees = $$("img.tee", hud);
    if ("MutationObserver" in window) {
      const mo = new MutationObserver(() => { ring.classList.remove("go"); void ring.offsetWidth; ring.classList.add("go"); });
      tees.forEach((t) => mo.observe(t, { attributes: true, attributeFilter: ["class"] }));
    }
    if (souris) {
      let raf = 0, last = null;
      const appliquer = () => {
        raf = 0;
        if (!last) return;
        const r = hud.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        const nx = clamp((last.clientX - cx) / (innerWidth / 2), -1, 1), ny = clamp((last.clientY - cy) / (innerHeight / 2), -1, 1);
        const dedans = last.clientX >= r.left && last.clientX <= r.right && last.clientY >= r.top && last.clientY <= r.bottom;
        hud.style.setProperty("--ry", `${(nx * 9).toFixed(2)}deg`);
        hud.style.setProperty("--rx", `${(-ny * 7).toFixed(2)}deg`);
        hud.style.setProperty("--px", nx.toFixed(3));
        hud.style.setProperty("--py", ny.toFixed(3));
        hud.style.setProperty("--mx", `${clamp(((last.clientX - r.left) / r.width) * 100, 0, 100).toFixed(1)}%`);
        hud.style.setProperty("--my", `${clamp(((last.clientY - r.top) / r.height) * 100, 0, 100).toFixed(1)}%`);
        hud.style.setProperty("--glare", dedans ? ".7" : "0");
      };
      addEventListener("pointermove", (e) => { if (scrollY > innerHeight * 1.1) return; last = e; if (!raf) raf = requestAnimationFrame(appliquer); }, { passive: true });
      document.addEventListener("pointerleave", () => { ["--rx", "--ry", "--px", "--py"].forEach((p) => hud.style.setProperty(p, "0")); hud.style.setProperty("--glare", "0"); });
    }
  }

  // ---------- Souris : lueur qui suit le curseur ----------
  if (souris) {
    const lueur = el("div", "fx-cursor");
    lueur.setAttribute("aria-hidden", "true");
    let tx = innerWidth / 2, ty = innerHeight / 3, x = tx, y = ty, boucle = false;
    const suivre = () => {
      x += (tx - x) * 0.12; y += (ty - y) * 0.12;
      lueur.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0)`;
      if (Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) requestAnimationFrame(suivre); else boucle = false;
    };
    addEventListener("pointermove", (e) => {
      tx = e.clientX; ty = e.clientY; lueur.classList.add("on");
      if (!boucle) { boucle = true; requestAnimationFrame(suivre); }
    }, { passive: true });
    document.addEventListener("pointerleave", () => lueur.classList.remove("on"));
  }

  // ---------- Lookbook : défilement automatique doux, arrêté au survol ou au toucher ----------
  const look = $(".look");
  if (look) {
    let pause = false, visible = false, timer = 0;
    const avancer = () => {
      if (pause || !visible) return;
      const f = $("figure", look);
      if (!f) return;
      const pas = f.getBoundingClientRect().width + 18;
      if (look.scrollLeft + look.clientWidth >= look.scrollWidth - 8) look.scrollTo({ left: 0, behavior: "smooth" });
      else look.scrollBy({ left: pas, behavior: "smooth" });
    };
    ["pointerenter", "focusin", "touchstart"].forEach((ev) => look.addEventListener(ev, () => { pause = true; }, { passive: true }));
    ["pointerleave", "focusout"].forEach((ev) => look.addEventListener(ev, () => { pause = false; }));
    look.addEventListener("touchend", () => { setTimeout(() => { pause = false; }, 4000); }, { passive: true });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((es) => es.forEach((e) => { visible = e.isIntersecting; }), { threshold: 0.4 }).observe(look);
    } else visible = true;
    timer = setInterval(avancer, 3000);
    addEventListener("pagehide", () => clearInterval(timer));
  }
})();
